export {};

declare global {
  // eslint-disable-next-line no-var
  var __SENTRY_ENABLED__: boolean | undefined;
}

globalThis.__SENTRY_ENABLED__ = __SENTRY_ENABLED__;
